export const Headerlogo = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="37"
        viewBox="0 0 33 37"
        fill="none"
      >
        <path
          d="M1.28772 8.10601L15.1698 16.4735V0.105957L12.1347 1.84458V11.3144L7.15781 8.24343L10.0256 6.43012V3.06042L1.28772 8.10601Z"
          fill="#F4E096"
        />
        <path
          d="M30.8949 28.3123L17.1293 19.9985V36.2585L20.1375 34.5229V25.1576L25.1144 28.2256L22.2466 30.0389V33.3041L30.8949 28.3123Z"
          fill="#F4E096"
        />
        <path
          d="M28.4751 6.63904L20.0539 11.365V5.40527L23.2593 7.31716L26.3511 5.41423L17.1293 0.0908203V16.4823L31.1607 8.19244L28.4751 6.63904Z"
          fill="#F4E096"
        />
        <path
          d="M3.93737 29.7731L12.2451 25.1128V31.0755L9.03972 29.1636L6.05837 30.9979L15.1697 36.2585V19.9985L1.24878 28.2226L3.93737 29.7731Z"
          fill="#F4E096"
        />
        <path
          d="M32.3021 10.23V20.5303L29.4313 18.8574V15.1411L26.19 16.9694L24.0362 18.1822L29.4313 21.3249L32.3021 22.9978V26.3824L21.0847 19.8462L18.2139 18.1733L19.9794 17.1785L21.1653 16.5093L23.3162 15.2965L29.4313 11.8491L32.3021 10.23Z"
          fill="#F4E096"
        />
        <path
          d="M0 26.3824V16.0821L2.87082 17.7551V21.4713L6.11207 19.643L8.26593 18.4302L2.87082 15.2875L0 13.6146V10.23L11.2174 16.7662L14.0882 18.4391L12.3227 19.4339L11.1367 20.1031L8.98587 21.3159L2.87082 24.7633L0 26.3824Z"
          fill="#F4E096"
        />
      </svg>
    </>
  );
};

export const HorizontalLine = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1438"
        height="2"
        viewBox="0 0 1438 2"
        fill="none"
      >
        <path
          d="M0.5 1H1438"
          stroke="url(#paint0_linear_2276_11154)"
          stroke-opacity="0.4"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2276_11154"
            x1="-2.05836e-08"
            y1="1.5"
            x2="1438"
            y2="1.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#181C2E" stop-opacity="0.556701" />
            <stop offset="0.515" stop-color="#C4C4C4" />
            <stop offset="1" stop-color="#02071B" stop-opacity="0.5" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const VerticalLine = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2"
        height="133"
        viewBox="0 0 2 133"
        fill="none"
      >
        <path
          d="M1 0L0.999994 133"
          stroke="url(#paint0_linear_2276_11156)"
          stroke-opacity="0.4"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2276_11156"
            x1="0.5"
            y1="-0.0462609"
            x2="0.499994"
            y2="133"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#181C2E" stop-opacity="0.556701" />
            <stop offset="0.515" stop-color="#C4C4C4" />
            <stop offset="1" stop-color="#02071B" stop-opacity="0.5" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export const Copybtn = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clip-path="url(#clip0_2276_11129)">
          <path
            d="M15 20H5C3.67441 19.9984 2.40356 19.4711 1.46622 18.5338C0.528882 17.5964 0.00158786 16.3256 0 15L0 5C0.00158786 3.67441 0.528882 2.40356 1.46622 1.46622C2.40356 0.528882 3.67441 0.00158786 5 0L15 0C16.3256 0.00158786 17.5964 0.528882 18.5338 1.46622C19.4711 2.40356 19.9984 3.67441 20 5V15C19.9984 16.3256 19.4711 17.5964 18.5338 18.5338C17.5964 19.4711 16.3256 19.9984 15 20ZM5 2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V15C2 15.7956 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H15C15.7956 18 16.5587 17.6839 17.1213 17.1213C17.6839 16.5587 18 15.7956 18 15V5C18 4.20435 17.6839 3.44129 17.1213 2.87868C16.5587 2.31607 15.7956 2 15 2H5ZM24 19V6C24 5.73478 23.8946 5.48043 23.7071 5.29289C23.5196 5.10536 23.2652 5 23 5C22.7348 5 22.4804 5.10536 22.2929 5.29289C22.1054 5.48043 22 5.73478 22 6V19C22 19.7956 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7956 22 19 22H6C5.73478 22 5.48043 22.1054 5.29289 22.2929C5.10536 22.4804 5 22.7348 5 23C5 23.2652 5.10536 23.5196 5.29289 23.7071C5.48043 23.8946 5.73478 24 6 24H19C20.3256 23.9984 21.5964 23.4711 22.5338 22.5338C23.4711 21.5964 23.9984 20.3256 24 19Z"
            fill="#F4E096"
          />
        </g>
        <defs>
          <clipPath id="clip0_2276_11129">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const RoadmapArrow = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="59"
        height="110"
        viewBox="0 0 59 110"
        fill="none"
      >
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M30.9999 101L30.9999 34L28.9999 34L28.9999 101L30.9999 101Z"
          fill="#252A3E"
        />
        <g filter="url(#filter0_d_2276_10848)">
          <circle cx="29.5" cy="29.5" r="9.5" fill="#F4E096" />
          <circle
            cx="29.5"
            cy="29.5"
            r="9.5"
            stroke="#F4E096"
            stroke-width="4"
          />
        </g>
        <rect
          x="29.6567"
          y="98"
          width="8"
          height="8"
          transform="rotate(45 29.6567 98)"
          fill="#F4E096"
        />
        <defs>
          <filter
            id="filter0_d_2276_10848"
            x="0"
            y="0"
            width="59"
            height="59"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset />
            <feGaussianBlur stdDeviation="9" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.956863 0 0 0 0 0.878431 0 0 0 0 0.588235 0 0 0 0.8 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2276_10848"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2276_10848"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </>
  );
};

export const Telegram_icon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M17.2208 3.0975L2.44583 8.795C1.4375 9.2 1.44333 9.7625 2.26083 10.0133L6.05416 11.1967L14.8308 5.65917C15.2458 5.40667 15.625 5.5425 15.3133 5.81917L8.2025 12.2367H8.20083L8.2025 12.2375L7.94083 16.1475C8.32416 16.1475 8.49333 15.9717 8.70833 15.7642L10.5508 13.9725L14.3833 16.8033C15.09 17.1925 15.5975 16.9925 15.7733 16.1492L18.2892 4.2925C18.5467 3.26 17.895 2.7925 17.2208 3.0975Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const Twitter_icon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.3608 6.66415C16.3716 6.80999 16.3716 6.95499 16.3716 7.09999C16.3716 11.5375 12.9941 16.6508 6.82163 16.6508C4.91996 16.6508 3.15329 16.1 1.66663 15.1433C1.93663 15.1742 2.19663 15.185 2.47746 15.185C3.98829 15.1886 5.45633 14.6834 6.64496 13.7508C5.94448 13.7381 5.26544 13.507 4.70266 13.0898C4.13988 12.6725 3.72145 12.0899 3.50579 11.4233C3.71329 11.4542 3.92163 11.475 4.13996 11.475C4.44079 11.475 4.74329 11.4333 5.02413 11.3608C4.26393 11.2073 3.58035 10.7953 3.08964 10.1947C2.59893 9.59417 2.33137 8.84219 2.33246 8.06665V8.02499C2.77996 8.27415 3.29913 8.42999 3.84913 8.45082C3.38837 8.14464 3.01056 7.72917 2.74941 7.24148C2.48826 6.75378 2.35189 6.20903 2.35246 5.65582C2.35246 5.03249 2.51829 4.46082 2.80913 3.96249C3.65257 5 4.70455 5.84879 5.89691 6.45387C7.08927 7.05895 8.39543 7.40683 9.73079 7.47499C9.67913 7.22499 9.64746 6.96582 9.64746 6.70582C9.64724 6.26495 9.73391 5.82837 9.90252 5.42102C10.0711 5.01367 10.3184 4.64355 10.6301 4.33181C10.9419 4.02007 11.312 3.77283 11.7193 3.60422C12.1267 3.43561 12.5633 3.34893 13.0041 3.34915C13.9708 3.34915 14.8433 3.75415 15.4566 4.40915C16.2081 4.26383 16.9287 3.9895 17.5866 3.59832C17.3361 4.374 16.8114 5.03174 16.1108 5.44832C16.7773 5.3723 17.4287 5.19703 18.0433 4.92832C17.5842 5.59757 17.0154 6.18444 16.3608 6.66415Z"
          fill="white"
        />
      </svg>
    </>
  );
};
export const Insta_icon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.8428 1.1243C3.85644 1.1243 2.91046 1.51603 2.21287 2.21336C1.51528 2.91068 1.12318 3.85651 1.1228 4.84287V14.7629C1.1228 15.7495 1.51473 16.6957 2.21237 17.3933C2.91 18.0909 3.8562 18.4829 4.8428 18.4829H14.7628C15.7492 18.4825 16.695 18.0904 17.3923 17.3928C18.0896 16.6952 18.4814 15.7492 18.4814 14.7629V4.84287C18.481 3.85676 18.0891 2.91115 17.3918 2.21386C16.6945 1.51658 15.7489 1.12468 14.7628 1.1243H4.8428ZM15.8328 4.84858C15.8328 5.13274 15.7199 5.40527 15.519 5.6062C15.3181 5.80713 15.0455 5.92001 14.7614 5.92001C14.4772 5.92001 14.2047 5.80713 14.0038 5.6062C13.8028 5.40527 13.6899 5.13274 13.6899 4.84858C13.6899 4.56442 13.8028 4.2919 14.0038 4.09097C14.2047 3.89004 14.4772 3.77716 14.7614 3.77716C15.0455 3.77716 15.3181 3.89004 15.519 4.09097C15.7199 4.2919 15.8328 4.56442 15.8328 4.84858ZM9.80423 6.83144C9.01616 6.83144 8.26037 7.1445 7.70311 7.70175C7.14586 8.259 6.8328 9.0148 6.8328 9.80287C6.8328 10.5909 7.14586 11.3467 7.70311 11.904C8.26037 12.4612 9.01616 12.7743 9.80423 12.7743C10.5923 12.7743 11.3481 12.4612 11.9053 11.904C12.4626 11.3467 12.7757 10.5909 12.7757 9.80287C12.7757 9.0148 12.4626 8.259 11.9053 7.70175C11.3481 7.1445 10.5923 6.83144 9.80423 6.83144ZM5.4028 9.80287C5.4028 8.63592 5.86637 7.51676 6.69153 6.6916C7.51669 5.86644 8.63585 5.40287 9.8028 5.40287C10.9698 5.40287 12.0889 5.86644 12.9141 6.6916C13.7392 7.51676 14.2028 8.63592 14.2028 9.80287C14.2028 10.9698 13.7392 12.089 12.9141 12.9141C12.0889 13.7393 10.9698 14.2029 9.8028 14.2029C8.63585 14.2029 7.51669 13.7393 6.69153 12.9141C5.86637 12.089 5.4028 10.9698 5.4028 9.80287Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const Bloglogo = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M1.81824 5.59885L11.3329 11.3339V0.115662L9.25269 1.3073V7.79786L5.84156 5.69304L7.80716 4.45021V2.14063L1.81824 5.59885Z"
          fill="#F4E096"
        />
        <path
          d="M22.1108 19.4481L12.6759 13.7499V24.8944L14.7377 23.7048V17.2859L18.1489 19.3887L16.1833 20.6315V22.8694L22.1108 19.4481Z"
          fill="#F4E096"
        />
        <path
          d="M20.4523 4.59358L14.6804 7.83271V3.74796L16.8774 5.05836L18.9965 3.7541L12.6759 0.105469V11.3401L22.293 5.65827L20.4523 4.59358Z"
          fill="#F4E096"
        />
        <path
          d="M3.63413 20.4493L9.32821 17.2552V21.342L7.13125 20.0316L5.08785 21.2888L11.3327 24.8944V13.7499L1.79138 19.3866L3.63413 20.4493Z"
          fill="#F4E096"
        />
        <path
          d="M23.0752 7.05444V14.1142L21.1075 12.9676V10.4205L18.886 11.6736L17.4098 12.5049L21.1075 14.6588L23.0752 15.8054V18.1252L15.3868 13.6453L13.4192 12.4987L14.6293 11.8169L15.4421 11.3583L16.9163 10.527L21.1075 8.16419L23.0752 7.05444Z"
          fill="#F4E096"
        />
        <path
          d="M0.935547 18.1252V11.0655L2.90319 12.2121V14.7592L5.12472 13.5061L6.60096 12.6748L2.90319 10.5209L0.935547 9.37426V7.05444L8.62389 11.5344L10.5915 12.681L9.38146 13.3628L8.56861 13.8214L7.09441 14.6527L2.90319 17.0155L0.935547 18.1252Z"
          fill="#F4E096"
        />
      </svg>
    </>
  );
};

export const Blogeye = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
      >
        <path
          d="M8.16992 10.5C8.16992 11.0802 8.40039 11.6366 8.81063 12.0468C9.22086 12.457 9.77726 12.6875 10.3574 12.6875C10.9376 12.6875 11.494 12.457 11.9042 12.0468C12.3145 11.6366 12.5449 11.0802 12.5449 10.5C12.5449 9.91984 12.3145 9.36344 11.9042 8.9532C11.494 8.54297 10.9376 8.3125 10.3574 8.3125C9.77726 8.3125 9.22086 8.54297 8.81063 8.9532C8.40039 9.36344 8.16992 9.91984 8.16992 10.5ZM18.8379 9.99609C16.9863 6.0957 14.1875 4.13281 10.4355 4.13281C6.68164 4.13281 3.88476 6.0957 2.03319 9.99805C1.95893 10.1553 1.92041 10.3271 1.92041 10.501C1.92041 10.6749 1.95893 10.8466 2.03319 11.0039C3.88476 14.9043 6.68359 16.8672 10.4355 16.8672C14.1895 16.8672 16.9863 14.9043 18.8379 11.002C18.9883 10.6855 18.9883 10.3184 18.8379 9.99609ZM10.3574 13.9375C8.45898 13.9375 6.91992 12.3984 6.91992 10.5C6.91992 8.60156 8.45898 7.0625 10.3574 7.0625C12.2559 7.0625 13.7949 8.60156 13.7949 10.5C13.7949 12.3984 12.2559 13.9375 10.3574 13.9375Z"
          fill="#F4E096"
        />
      </svg>
    </>
  );
};

export var Phool = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="33"
        viewBox="0 0 35 33"
        fill="none"
      >
        <path
          d="M31.4005 15.7772C32.996 16.0431 34.1261 16.9548 34.563 18.142L33.1764 14.3526C32.7396 13.1655 31.6189 12.2538 30.0139 11.9879L23.328 10.8577L24.7145 14.6471L31.4005 15.7772Z"
          fill="url(#paint0_linear_2276_10896)"
        />
        <path
          d="M1.71268 15.2549C2.70987 12.9472 5.68243 11.4466 8.3511 11.893L15.0465 13.0231L13.6599 9.23381L6.96451 8.10367C4.29584 7.65731 1.32328 9.15784 0.326087 11.4656C-0.0727894 12.3868 -0.0917975 13.2986 0.193114 14.0963L1.5797 17.8856C1.29479 17.0974 1.3138 16.1857 1.71268 15.2549Z"
          fill="url(#paint1_linear_2276_10896)"
        />
        <path
          d="M8.8164 29.7854L7.42981 25.9961C7.1449 25.2078 7.1639 24.2961 7.56278 23.3654L10.0605 17.5817L11.4471 21.371L8.94937 27.1547C8.55049 28.0759 8.53149 28.9876 8.8164 29.7854Z"
          fill="url(#paint2_linear_2276_10896)"
        />
        <path
          d="M24.1828 3.8775C25.3794 4.07694 26.3196 4.64676 26.8895 5.40653C27.0794 5.66295 27.2313 5.93837 27.3453 6.23278L25.9587 2.44345C25.5219 1.25632 24.4012 0.344601 22.7962 0.0786829C20.1275 -0.367678 17.155 1.13286 16.1578 3.44065L13.66 9.22434L15.0466 13.0137L17.5444 7.22996C18.5415 4.92218 21.5141 3.42165 24.1828 3.86801V3.8775Z"
          fill="url(#paint3_linear_2276_10896)"
        />
        <g style="mix-blend-mode:color-dodge">
          <path
            d="M1.51329 15.141C1.03844 16.2331 1.06694 17.3633 1.57978 18.313C2.1496 19.3482 3.26073 20.0794 4.6378 20.3168L11.1718 21.4185L8.74053 27.0503C8.26568 28.1424 8.29418 29.2726 8.80702 30.2223C9.36734 31.2575 10.488 31.9887 11.8651 32.2262C14.5813 32.682 17.6298 31.1435 18.6459 28.7882L21.1057 23.0995L27.6967 24.2106C30.4223 24.6665 33.4614 23.128 34.4776 20.7727C34.9524 19.6806 34.9239 18.5504 34.4111 17.6007C33.8508 16.5655 32.7301 15.8343 31.353 15.5968L24.8285 14.4952L27.2598 8.86341C27.7346 7.77125 27.7061 6.6411 27.1933 5.6914C26.633 4.65622 25.5123 3.92495 24.1353 3.68752C21.4191 3.23166 18.3705 4.77018 17.3544 7.12545L14.9041 12.8142L8.31315 11.703C6.07185 11.3231 3.60266 12.3108 2.24458 13.9823C1.95967 14.3337 1.71275 14.7231 1.5323 15.141H1.51329ZM17.5823 7.22991C18.551 4.97911 21.4666 3.50708 24.0783 3.94394C25.3794 4.16238 26.424 4.84616 26.9559 5.81486C27.4307 6.69809 27.4592 7.74276 27.0128 8.75894L24.4487 14.6946L31.3055 15.8532C32.6066 16.0717 33.6513 16.7555 34.1832 17.7242C34.658 18.6074 34.6865 19.6521 34.2401 20.6682C33.2714 22.919 30.3558 24.3911 27.7441 23.9542L20.9538 22.8146L18.418 28.6932C17.4493 30.944 14.5338 32.4161 11.9221 31.9792C10.621 31.7608 9.57628 31.077 9.04444 30.1083C8.56959 29.2251 8.5411 28.1804 8.98746 27.1642L11.5517 21.2286L4.69478 20.0699C3.39368 19.8515 2.34904 19.1677 1.8172 18.199C1.34235 17.3158 1.31386 16.2711 1.76022 15.2549C2.72892 13.0041 5.64448 11.5321 8.25617 11.9689L15.0466 13.1181L17.5823 7.24891V7.22991Z"
            fill="#00E7CB"
          />
        </g>
        <path
          d="M34.4395 20.7727C33.4423 23.0805 30.4698 24.581 27.8011 24.1347L21.1152 23.0045L18.6175 28.7882C17.6203 31.096 14.6477 32.5966 11.979 32.1502C9.31036 31.7038 7.95228 29.4625 8.94947 27.1548L11.4472 21.371L4.75174 20.2409C2.08307 19.7945 0.725045 17.5532 1.72223 15.2455C2.71942 12.9377 5.69199 11.4371 8.36066 11.8835L15.0561 13.0137L17.5538 7.22994C18.551 4.92216 21.5236 3.42163 24.1922 3.86799C26.8609 4.31435 28.219 6.55565 27.2218 8.86344L24.7241 14.6471L31.41 15.7773C34.0786 16.2236 35.4367 18.465 34.4395 20.7727Z"
          fill="#00E7CB"
        />
        <defs>
          <linearGradient
            id="paint0_linear_2276_10896"
            x1="28.9455"
            y1="18.142"
            x2="28.9455"
            y2="10.8577"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00E7CB" />
            <stop offset="1" stop-color="#008171" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2276_10896"
            x1="7.52326"
            y1="17.8856"
            x2="7.52326"
            y2="8.02511"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00E7CB" />
            <stop offset="1" stop-color="#008171" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_2276_10896"
            x1="9.3419"
            y1="29.7854"
            x2="9.3419"
            y2="17.5817"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00E7CB" />
            <stop offset="1" stop-color="#008171" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_2276_10896"
            x1="20.5027"
            y1="13.0137"
            x2="20.5027"
            y2="0.00012207"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#00E7CB" />
            <stop offset="1" stop-color="#008171" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};
